var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnstackMiniLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.55745 11.2472L0.709539 11.5073C0.184524 11.6684 0.0830111 12.398 0.542468 12.7081L8.85948 18.3217C9.70565 18.8928 10.7944 18.8928 11.6405 18.3217L19.9575 12.7081C20.417 12.398 20.3155 11.6684 19.7905 11.5073L18.9426 11.2472L12.3492 13.9627C11.0146 14.5124 9.48558 14.5124 8.15092 13.9627L1.55745 11.2472Z",
    fill: "#14213D",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07886 1.41054C9.84343 1.19649 10.6566 1.19649 11.4211 1.41054L19.7534 3.74329C20.4155 3.92865 20.4155 4.82135 19.7534 5.00671L11.4211 7.33946C10.6566 7.55351 9.84343 7.55351 9.07886 7.33946L0.746565 5.00671C0.0844789 4.82135 0.0844779 3.92865 0.746564 3.74329L9.07886 1.41054Z",
    fill: "#14213D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.12141 7.33872L0.684098 7.78269C0.135661 7.95209 0.0973714 8.6181 0.623608 8.83483L8.86487 12.229C9.74215 12.5903 10.7579 12.5903 11.6351 12.229L19.8764 8.83483C20.4026 8.6181 20.3643 7.9521 19.8159 7.78269L18.3786 7.33872L11.9266 9.14504C10.8314 9.45166 9.66857 9.45166 8.57336 9.14504L2.12141 7.33872Z",
    fill: "#14213D",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnstackMiniLogo);
export default __webpack_public_path__ + "static/media/unstack-mini-logo.8608fc18ff4939f2816bedb1a6006ba2.svg";
export { ForwardRef as ReactComponent };